// Shared facts about a Task's own fields.

// Task.TASK_CATEGORY_CHOICES, in the model's order. The client page's New Task
// form offered only the first two for as long as it existed, so T-Slips work
// could not be created from it at all.
export const TASK_CATEGORIES = [
  { value: 'corporate', label: 'Corporate (T2)' },
  { value: 'personal', label: 'Personal (T1)' },
  { value: 'tslips', label: 'T-Slips' },
];

// The DATE a task's fiscal year ends on, as YYYY-MM-DD, by the same rule
// Client.get_year_end_date uses for money: a corporate's fiscal month end in
// that year, Dec 31 for everyone else. Task.year_end_date is what the planning
// grid slots a task by (planned_period falls back to its month) and what
// roll-forward derives the next due date from, so a task created without one
// is bookable but unplannable.
export function taskYearEndDate(year, isCorporate, fiscalMonthEnd) {
  if (!Number.isFinite(Number(year))) return null;
  const y = Number(year);
  if (!isCorporate || !fiscalMonthEnd) return `${y}-12-31`;
  const m = Number(fiscalMonthEnd);
  if (!Number.isFinite(m) || m < 1 || m > 12) return `${y}-12-31`;
  const lastDay = new Date(y, m, 0).getDate();
  return `${y}-${String(m).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
}
